<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "AnalyticComponent"
}
</script>

<style scoped>

</style>
